<template>
	<div class="development-page">
		<section class="sec-01">
			<div class="container-box">
				<h2>
					{{ $t('new_ui.development_main_page_v2.sec_01.title.one') }}
					<strong>{{
						$t('new_ui.development_main_page_v2.sec_01.title.two')
					}}</strong
					><br />
					{{ $t('new_ui.development_main_page_v2.sec_01.title.three') }}
					<br />
					{{ $t('new_ui.development_main_page_v2.sec_01.title.four') }}
				</h2>

				<div class="btn-box">
					<a href="/development" class="btn-type-02">
						{{ $t('new_ui.development_main_page_v2.sec_01.btn.two') }}
					</a>
				</div>
			</div>
		</section>
	</div>
</template>
